export default "__VITE_ASSET__DvcAnWFv__"